import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportService } from '../../service/report.service';
import { NotifierService } from 'angular-notifier';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-sig-test',
  templateUrl: './sig-test.component.html',
  styleUrls: ['./sig-test.component.scss']
})
export class SigTestComponent implements OnInit {


  // public sigTestForm = new FormGroup({
  //   // cuts: this.formBuilder.array([this.createCut(this.reportService.fileUUID)]),
  //   confidenceLevel : new FormControl('', [Validators.required]),
  //   compaireType : new FormControl('', [Validators.required]),
  //   withRespect: new FormControl('', [Validators.required]),
  //   toColumn:new FormControl('', [Validators.required]),
  //   options:new FormControl('', [Validators.required])
  // });
  sigCopyMap: any = null;

  constructor(public reportService: ReportService,
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,

  ) { }

  ngOnInit(): void {
    this.reportService.sigTreeItemsFortoColumn = this.setCustomTextName(this.reportService.sigTreeItemsFortoColumn)
    this.reportService.sigTreeItemsForWithRespect = this.setCustomTextName(this.reportService.sigTreeItemsForWithRespect)
    // this.columnChange([Object.keys(this.reportService.selectedCut['value']['topcut'])[0]])
    this.reportService.createSigTreeForFullCrosstab();
    this.reportService.sigFullTreeItemsForWithRespect = this.setCustomTextName(this.reportService.sigFullTreeItemsForWithRespect)
    this.reportService.sigFullTreeItemsFortoColumn = this.setCustomTextName(this.reportService.sigFullTreeItemsFortoColumn)
  }

  setCustomTextName(parent: any) {
    return parent.map((el:any)=> {
        if(el.name) {
            el.custom_selected_text = this.getCustomName(el.name, el.parentName)
        }

        if(el.children && el.children.length) {
            el.children = this.setCustomTextName(el.children)
        }
        return el
    })
  }

  // sigTestingOnChange(event){
  //   // event.stopPropagation();
  // }

  getCustomName(name:string, parentName:string = "") {
    let parentArr = parentName.split("---")
    if(parentArr.length) parentArr.shift();
    parentArr.push(name)
    return parentArr.join(">")
  }

  createCut(fileUUID): FormGroup {
    return this.formBuilder.group({
      topcut: this.formBuilder.array([this.createTopcut()]),
      fileUUID: new FormControl(fileUUID),
    });
  }

  createTopcut(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      options: new FormControl([], [Validators.required]),
    });
  }

  // onSubmit() {
  //   if (this.reportService.isData) {
  //     if (this.reportService.sigComparetype === 'AmongColumn') {
  //       if (this.reportService.sigConfidenceLevel && this.reportService.sigConfidenceLevel != '') {
  //         this.OpenSigModal(1);
  //         this.reportService.sigsubmitForm['type'] = this.reportService.sigComparetype;
  //         this.reportService.sigsubmitForm['confidence'] = this.reportService.sigConfidenceLevel;
  //         this.reportService.sigfromAmongarr = [{ withRespect: '', toColumn: [] }];
  //         let body = {};
  //         body['data'] = this.reportService.mainJsonDataForSig;
  //         body['significance_test'] = this.reportService.sigsubmitForm;
  //         body['file_uuid'] = this.reportService.fileUUID;
  //         body['sigType'] = 'crossTab'
  //         body['small_base'] = this.reportService.sigSmallBaseToggleButton;
  //         // console.log(body, 'body');
  //         this.reportService.getSignificanceTable(body);
  //         this.reportService.isSignificanceTest = false;
  //         this.reportService.sigsubmitForm = {};
  //         this.reportService.sigComparetypeCopy = this.reportService.sigComparetype;
  //         this.reportService.sigConfidenceLevelCopy = this.reportService.sigConfidenceLevel;
  //       }
  //       else {
  //         this.notifier.notify('error', 'Please select confidence level');
  //       }
  //     }
  //     else {
  //       let d = this.reportService.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
  //       if (d) {
  //         this.notifier.notify('error', 'Please select  value')
  //       }
  //       else {
  //         if (this.reportService.sigConfidenceLevel && this.reportService.sigConfidenceLevel != '') {
  //           this.OpenSigModal(1);
  //           this.reportService.sigsubmitForm['type'] = this.reportService.sigComparetype;
  //           this.reportService.sigsubmitForm['confidence'] = this.reportService.sigConfidenceLevel;
  //           this.reportService.sigsubmitForm['significanceValueArray'] = this.reportService.sigfromAmongarr;
  //           let body = {};
  //           body['data'] = this.reportService.mainJsonDataForSig;
  //           body['significance_test'] = this.reportService.sigsubmitForm;
  //           body['file_uuid'] = this.reportService.fileUUID;
  //           body['sigType'] = 'crossTab'
  //           body['small_base'] = this.reportService.sigSmallBaseToggleButton;
  //           this.reportService.getSignificanceTable(body);
  //           this.reportService.isSignificanceTest = false;
  //           this.reportService.sigsubmitForm = {};
  //           this.reportService.sigComparetypeCopy = this.reportService.sigComparetype;
  //           this.reportService.sigConfidenceLevelCopy = this.reportService.sigConfidenceLevel;
  //         }
  //         else {
  //           this.notifier.notify('error', 'Please select confidence level');
  //         }
  //       }
  //     }
  //   }
  //   else {
  //     if (this.reportService.sigComparetype === 'AmongColumn') {
  //       if (this.reportService.sigConfidenceLevel && this.reportService.sigConfidenceLevel != '') {
  //         this.OpenSigModal(1);
  //         this.reportService.sigsubmitForm['type'] = this.reportService.sigComparetype;
  //         this.reportService.sigsubmitForm['confidence'] = this.reportService.sigConfidenceLevel;
  //         this.reportService.sigfromAmongarr = [{ withRespect: '', toColumn: '' }];
  //         let body = {};
  //         body['significance_test'] = this.reportService.sigsubmitForm;
  //         body['file_uuid'] = this.reportService.fileUUID;
  //         body['sigType'] = 'all'
  //         body['small_base'] = this.reportService.sigSmallBaseToggleButton;
  //         this.reportService.getSignificanceTable(body);
  //         this.reportService.isSignificanceTest = false;
  //         this.reportService.sigsubmitForm = {};
  //         this.reportService.sigComparetypeCopy = this.reportService.sigComparetype;
  //         this.reportService.sigConfidenceLevelCopy = this.reportService.sigConfidenceLevel;
  //       }
  //       else {
  //         this.notifier.notify('error', 'Please select confidence level');
  //       }
  //     }
  //     else {
  //       let d = this.reportService.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
  //       if (d) {
  //         this.notifier.notify('error', 'Please select  value');
  //       }
  //       else {
  //         if (this.reportService.sigConfidenceLevel && this.reportService.sigConfidenceLevel != '') {
  //           this.OpenSigModal(1);
  //           this.reportService.sigsubmitForm['type'] = this.reportService.sigComparetype;
  //           this.reportService.sigsubmitForm['confidence'] = this.reportService.sigConfidenceLevel;
  //           this.reportService.sigsubmitForm['significanceValueArray'] = this.reportService.sigfromAmongarr;
  //           let body = {};
  //           body['significance_test'] = this.reportService.sigsubmitForm;
  //           body['file_uuid'] = this.reportService.fileUUID;
  //           body['sigType'] = 'all'
  //           body['small_base'] = this.reportService.sigSmallBaseToggleButton;
  //           this.reportService.getSignificanceTable(body);
  //           this.reportService.isSignificanceTest = false;
  //           this.reportService.sigsubmitForm = {};
  //           this.reportService.sigComparetypeCopy = this.reportService.sigComparetype;
  //           this.reportService.sigConfidenceLevelCopy = this.reportService.sigConfidenceLevel;
  //         }
  //         else {
  //           this.notifier.notify('error', 'Please select confidence level');
  //         }
  //       }
  //     }
      
  //   }
  // }

  // OpenSigModal(N:number) {
  //   if(N === 1)
  //   {
  //     this.dialog.open(SigTestModalComponent,
  //     {
  //       width: "400px",
  //       height: '270px',
  //       data:{
  //         type:'SigTestModal'
  //       }
  //     });
  //     setTimeout(() => {
  //       this.dialog.closeAll();
  //     }, 5000)
  //   }
  //   else
  //   {
  //     this.dialog.open(SigTestModalComponent,
  //     {
  //       width: "540px",
  //       height: '220px',
  //       data:{
  //         type:'calculateModal'
  //       }
  //     });
  //   }
  
  // }



  appendSection() {
    let d = this.reportService.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
    if (d) {
      this.notifier.notify('error', 'Please select value');
    }
    else {
      this.reportService.sigfromAmongarr.push({ withRespect: '', toColumn: [] });
    }
  }
  RemoveSection(i: number) {
    if (i == 0) {
      this.reportService.sigfromAmongarr.splice(i, 1);
      if (this.reportService.sigfromAmongarr.length == 0) {
        this.reportService.sigfromAmongarr.push({ withRespect: '', toColumn: [] });
      }
    }
    else {
      this.reportService.sigfromAmongarr.splice(i, 1);
    }
  }
  CopySection(matTrigger: MatMenuTrigger, i: number) {
    // event.stopPropagation()
    if (this.reportService.sigfromAmongarr[i]['withRespect'] === '' || this.reportService.sigfromAmongarr[i]['toColumn'].length === 0) {
      this.notifier.notify('error', 'Cannot copy blank or undefined value');
      if(matTrigger.openMenu) matTrigger.closeMenu()
    }
    else {

      this.sigCopyMap = {}
      this.sigCopyMap['sigCopy'] = []
      // this.sigCopyMap['sigTreeItemsFortoColumn'] = this.reportService.sigTreeItemsFortoColumn
      // this.sigCopyMap['sigTreeItemsForWithRespect'] = this.reportService.sigTreeItemsForWithRespect

      this.sigCopyMap['sigTreeItemsFortoColumn'] = this.reportService.sigTestingOn == 'FullCrosstab' ? this.reportService.sigFullTreeItemsFortoColumn : this.reportService.sigTreeItemsFortoColumn
      this.sigCopyMap['sigTreeItemsForWithRespect'] = this.reportService.sigTestingOn == 'FullCrosstab' ? this.reportService.sigFullTreeItemsForWithRespect : this.reportService.sigTreeItemsForWithRespect
      this.sigCopyMap['withRespect'] = this.reportService.sigfromAmongarr[i]['withRespect']
      this.sigCopyMap['toColumn'] = this.reportService.sigfromAmongarr[i]['toColumn']
      this.sigCopyMap.sigfromAmongCopy = this.getSigCopyData(JSON.parse(JSON.stringify(this.sigCopyMap['sigTreeItemsFortoColumn'])))
      // console.log("this.sigCopyMap",this.sigCopyMap)
      matTrigger.openMenu()
      setTimeout(() => {
        const treeElem = document.getElementById('sig-copy-tree-select-main');
        treeElem.click()
      }, 200)
      // let arr = { withRespect: this.reportService.sigfromAmongarr[i]['withRespect'], toColumn: this.reportService.sigfromAmongarr[i]['toColumn'] };
      // this.reportService.sigfromAmongarr.push(arr);
    }
  }

  getSigCopyData(parent: any[]) {
    return parent.map((el: any)=> {
      if(el.children && el.children.length) {
          let hasChild = el.children.find(c=> c.children && c.children.length)
          if(hasChild) {
            el.children = this.getSigCopyData(el.children)
          } else {
            delete el.children
          }
        }
        return el
    })
  }

  resetSigSelection(){
    this.reportService.sigfromAmongarr = [{ withRespect: '', toColumn: [] }];
  }

  cancelCopy(clickMenuTrigger: MatMenuTrigger) {
    clickMenuTrigger.closeMenu()
    this.sigCopyMap = null
  }

  applyCopy(clickMenuTrigger: MatMenuTrigger) {
    let sigCopy = this.sigCopyMap['sigCopy']
    if(!sigCopy || !sigCopy.length) return
    
    let withRespectName = this.sigCopyMap['withRespect']['name']
    // console.log("withRespectName ===> ",withRespectName)
    // console.log("sigTreeItemsFortoColumn -> ",this.sigCopyMap['sigTreeItemsFortoColumn'])
    // console.log("sigTreeItemsForWithRespect -> ",this.sigCopyMap['sigTreeItemsForWithRespect'])
    // console.log("sigCopyMap 1111 -> ",this.sigCopyMap)
    let errorColor = 'error', errorMessage = null
    for(let copied of sigCopy) {
      let toColumn = [], withRespect
      
      let selectedCoumn = this.getToColumnData(this.sigCopyMap['sigTreeItemsFortoColumn'], copied.id)
      let toColumnIdx = selectedCoumn.findIndex(c=> c.name == withRespectName)

      let finalParentName = copied.parentName + "---" + copied.name
      let selectedWithRespect = this.getWithRespectData(this.sigCopyMap['sigTreeItemsForWithRespect'],finalParentName)
      // console.log("selectedWithRespect => ",selectedWithRespect)
      if(selectedWithRespect) withRespect = selectedWithRespect.find(c=> c.name == withRespectName)
      // console.log("withRespect ==> ",withRespect)

      if(toColumnIdx >= 0) {
        for(let copy of selectedCoumn) {
          let toBeIncludedIndex = this.sigCopyMap['toColumn'].findIndex(e=> e.name == copy.name)
          if(toBeIncludedIndex >= 0) {
            toColumn.push(copy)
          }
        }
      }
      // console.log("toColumn ====> ",toColumn)
      if(withRespect && toColumn.length) {
        let alreadyExistingIdx = this.reportService.sigfromAmongarr.findIndex(sigData => sigData.withRespect && sigData.withRespect.id == withRespect.id)
        if(alreadyExistingIdx === -1) {
          let copiedFinalItem = { toColumn, withRespect }
          this.reportService.sigfromAmongarr.push(copiedFinalItem)
        } else if(!errorMessage) {
          errorMessage = "Sig Already Selected for "+copied.name
          errorColor = "info"
        }

      } else if(!errorMessage) {
        errorMessage = "Invalid select for "+copied.name
      }
    }

    if(errorMessage) this.notifier.notify(errorColor, errorMessage)

    clickMenuTrigger.closeMenu()
    this.sigCopyMap = null
  }

  getWithRespectData(_withRespect: any, finalParentName: string) {
      let details = null;
      let isParentMatched = _withRespect[0].parentName == finalParentName
      if(isParentMatched) {
        details =  _withRespect
      } else {
        for(let wRespect of _withRespect) {
          if(wRespect.children) {
            let isFound = this.getWithRespectData(wRespect.children, finalParentName)
            if(isFound) details = isFound
          }
        }
      }
    
      return details
    }

  getToColumnData(parent:any, id:string) {
    let details = null;
    for(let child of parent) {
      if(!child.children || !child.children.length) continue;

      if(child.id == id) {
        details = child.children
        break;
      }

      let result = this.getToColumnData(child.children, id)
      if(result) {
        details = result
        break;
      }
    }
    return details
  }
  getSelectedNames(arr) {
    arr = arr.map(el=> el.custom_selected_text)
    return arr.join(", ")
  }
  onSubmit(){
    
    this.reportService.onSubmitSignificanceRequest();
  }
  smallbaseChange(){
    this.reportService.sigSmallBaseToggleButton = !this.reportService.sigSmallBaseToggleButton;
  }

  saveResultChange(){
    this.reportService.sigSaveResultToggleButton = !this.reportService.sigSaveResultToggleButton;
  }

  // onCalculateShow(){
  //   this.smallBasePopup();
  // }
  // smallBasePopup(){
  //   this.dialog.open(SigSmallbasePopupComponent,{
  //     width:'540px',
  //     height:'220px',
  //   })
  // }




  // columnChange(columns){
  //   let filteredColumns = [];
  //   columns.forEach(question_name => {
  //     filteredColumns = this.sigTestForm.value.columns.filter(item =>{
  //       return item.question_name == question_name
  //     })
  //     if (filteredColumns.length == 0) {
  //       this.addColumn(question_name);
  //     }
  //   });
  //   this.unselectColumns(columns);
  // }

  // public addColumn(question_name): void {
  //   let items = this.sigTestForm.get('columns') as FormArray;
  //   items.push(this.createColumn(question_name));
  // }

  // unselectColumns(columns){ 
  //   // remove colomn
  //   if (columns.length == 0) {
  //     this.removeColumn(0)
  //   }else{
  //     let indexes = [];
  //     this.sigTestForm.value.columns.forEach((item,index) =>{
  //       if (!columns.includes(item.question_name)) {
  //         indexes.push(JSON.stringify(index)) 
  //       }
  //     })
  //     setTimeout(()=>{
  //       indexes.forEach(our_index => {
  //         this.removeColumn(our_index)
  //       });
  //     })
  //   }
  // }

  // removeColumn(index): void {
  //   let items = this.sigTestForm.get('columns') as FormArray;
  //   items.removeAt(index);
  // }
  // ShowValue = (event:any) =>
  // {
  // }

  // public createColumn(question_name){
  //   return this.formBuilder.group({
  //     question_name : new FormControl(question_name),
  //     values : this.formBuilder.array([this.createColumnValues()]),
  //     // columnOption: new FormControl(column['value']['topcut'])
  //   });
  // }

  // public createColumnValues(){
  //   return this.formBuilder.group({
  //     mergerd_values_name : new FormControl(''),
  //     values_merged : new FormControl([''], [Validators.required]),
  //   });
  // }

}


